import autoBind from 'auto-bind';

class Observer {
  public isOnce: boolean;
  public rootMargin: string;
  public isVisible: boolean;
  public observer: IntersectionObserver | null;

  constructor({ isOnce = false, rootMargin = '0px 0px 0px 0px' }) {
    this.isOnce = isOnce;
    this.rootMargin = rootMargin;
    this.isVisible = false;
    this.observer = null;

    autoBind(this);
    this.createObserver();
  }

  createObserver() {
    // Fallback for browsers that don't support IntersectionObserver
    if (!('IntersectionObserver' in window)) {
      this.animateIn();
      return;
    }

    this.observer = new window.IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.animateIn(entry.target);

            if (this.isOnce) {
              this.unobserve(entry.target);
            }
          } else {
            this.animateOut(entry.target);
          }
        });
      },
      {
        rootMargin: this.rootMargin,
      },
    );
  }

  observe(targets: JQuery<HTMLElement>) {
    if (!this.observer) return;

    const $targets = $(targets);
    $targets.each((i, target) => {
      this.observer?.observe(target);
    });
  }

  unobserve(target: Element | JQuery<HTMLElement>) {
    if (!this.observer) return;
    const $items = $(target);
    $items.each((i, item) => {
      this.observer?.unobserve(item);
    });
  }

  animateIn(target?: Element) {
    this.isVisible = true;
  }

  animateOut(target?: Element) {
    this.isVisible = false;
  }
}

export default Observer;
